import React, { Component } from "react";
import { CKEditor } from 'ckeditor4-react';
import { 
  Segment, 
  Button, 
  Form, 
  Grid,
  Tab,
  Accordion
} from "semantic-ui-react";

import request from "../../utils/request";
import { baseUrl } from "../../utils/constants";
import ResponseMessage from "../../components/common/ResponseMessage";
import EcomImageForm from "../../components/content/EcomPagesImageForm";

CKEditor.editorUrl = `${baseUrl}/plugins/ckeditor/ckeditor.js`;

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isGridLoading: false,
      content: "",
      xhrMessage: "",
      xhrStatus: "",
      imageOne: "",
      imageTwo: ""
    };
  }

  componentDidUpdate = prevProps => {
    if (this.props.match !== prevProps.match) {
      this.setState({
        isLoading: true,
        content: "",
        xhrMessage: "",
        xhrStatus: ""
      }, this.fetchData);
    }
  };
  componentDidMount = () => {
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState({
      isLoading: true,
      content: "",
      xhrMessage: "",
      xhrStatus: ""
    });
  };

  startLoading = () => {
    this.setState({ isLoading: true });
  };
  doneLoading = () => {
    this.setState({ isLoading: false });
  };

  fetchData = async () => {
    let self = this;
    self.startLoading();
    let currentPage = this.props.match.params.method;
    let page = await request.get(this, `api:/content/page/${currentPage}`, {});
    
    let content = (page && page.data && page.data.content && page.data.content !== "") ? page.data.content.trim() : "";
    let assetOneURL = (page && page.data && page.data.asset_one_url) ? page.data.asset_one_url : "";
    let assetTwoURL = (page && page.data && page.data.asset_two_url) ? page.data.asset_two_url : "";
    self.setState({ 
        content: content,
        imageOne: assetOneURL,
        imageTwo: assetTwoURL 
      }, 
      this.doneLoading
    );
  };

  handleChange = e => {
    this.setState({ content: e.editor.getData() });
  };

  handleSubmit = () => {
    this.startLoading();
    let currentPage = this.props.match.params.method;
    let payload = {
      content: this.state.content,
      assetOneUrl: this.state.imageOne,
      assetTwoUrl: this.state.imageTwo
    };

    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    return request.put(this, `api:/content/page/${currentPage}`, payload).then(resp => {
      this.setState({
          xhrStatus: resp.success ? "success" : "error",
          xhrMessage: resp.message
        },
        this.doneLoading
      );
      
      if (resp.success) {
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    });
  };

  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }

  handleCopyURL = (id) => {
    if (id === "imageOne") {
      navigator.clipboard.writeText(this.state.imageOne);
    }
    else if (id === "imageTwo") {
      navigator.clipboard.writeText(this.state.imageTwo);
    }

    // Popup saying URL was copied to clipboard
    let assetUploaded = id === "imageOne" ? "Image One": "Image Two";
    this.setState( {
      xhrStatus: "success",
      xhrMessage: `${assetUploaded}'s url was copied to clipboard`
    });      
    setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
  };

  handleTrash = (id) => {
    if (id === "imageOne") {
      this.setState({ imageOne: "" });
    }
    else if (id === "imageTwo") {
      this.setState({ imageTwo: "" });
    }
  };

  handleUpload = (id, files) => {
    this.setState({ isGridLoading: true });
    let fileName = this.props.match.params.method + "_" + id; // "<currentPage>_" + id
    let file = files[0];

    // Initial FormData
    let formData = new FormData();
    formData.append("name", fileName);
    formData.append("img_file", file);
    formData.append("img_type", "assets");

    return request.post(this, "api:/content/upload-asset", formData).then(resp => {
      this.setState({ isGridLoading: false });

      if (resp.status === "success") {

        let imgUrl = resp.data.url;
        if (id === "imageOne") {
          this.setState({ imageOne: imgUrl });
        } 
        else if (id === "imageTwo") {
          this.setState({ imageTwo: imgUrl });
        }

        // Notify user of success and clear after 4 seconds
        let assetUploaded = id === "imageOne" ? "Image One": "Image Two";
        this.setState( {
          xhrStatus: "success",
          xhrMessage: `${assetUploaded} was uploaded successfully`
        });      
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
      else if (resp.status === 'pixel_error') {
        alert(resp.message);
      } else {
        alert ("There was an error uploading the image. Please ensure there are no spaces or special characters in the filename and that the image is smaller than 2MB");
      }
    });
  };

  renderAssetsTab = () => {
    const { 
      imageOne,
      imageTwo
    } = this.state;
    const panels = [];

    // Asset 1
    panels.push({
      key: 'panel-One',
      title: {
        content: "Image One",
      },
      content: {
        content: (          
          <EcomImageForm
            imgURL={imageOne}
            id = "imageOne"
            accept = "image/*"
            drop = {this.handleUpload}
            copyURL = {this.handleCopyURL}
            trash = {this.handleTrash}
          />
        )
      }
    });

    // Asset 2   
    panels.push({
      key: 'panel-Two',
      title: {
        content: "Image Two",
      },
      content: {
        content: (          
          <EcomImageForm
            imgURL={imageTwo}
            id = "imageTwo"
            accept = "image/*"
            drop = {this.handleUpload}
            copyURL = {this.handleCopyURL}
            trash = {this.handleTrash}
          />
        )
      }
    });
    
    return (
      <Tab.Pane>
        <Accordion fluid styled panels={panels} />
      </Tab.Pane>
    )
  }

  render() {
    const { content, isLoading, isGridLoading, xhrMessage, xhrStatus } = this.state;

    // Setup image upload 
    const panes = [];
    panes.push({
      menuItem: 'Assets',
      render: () => this.renderAssetsTab()
    });

    var styles = `
      .cke_dialog_contents_body tr:nth-child(3) table td .cke_dialog_ui_hbox_first:before {
        content:"Append % to Width and Height to use percentages";
        color: green
      }
    `
  var styleSheet = document.createElement("style")
  styleSheet.innerText = styles
  document.head.appendChild(styleSheet)
    return (
      <Segment basic>
        <Form
          id="pages"
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
          {!isLoading && (<CKEditor
            config={{
              toolbarGroups: [
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'others', groups: [ 'others' ] },
                '/',
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'colors', groups: [ 'colors' ] }
              ],
              removeButtons:'',
              format_tags: 'p;h1;h2;h3;pre',
              removeDialogTabs: 'image:advanced;link:advanced',
              extraPlugins: "justify,font,colorbutton,colordialog"
            }}
            onChange={this.handleChange}
            initData={content}
          />)}
          {!isLoading && <Button
            primary
            icon="save"
            content="Save"
            onClick={this.handleSubmit}
            floated="right"
            style={{ marginTop: "5px" }}
          />}
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
        <br/><br/>
        {!isLoading &&
          <Segment 
            basic 
            loading={isGridLoading}
          >
            <Grid >
              <Grid.Column width={8}> 
                <Tab menu={{ attached: 'top' }} panes={panes} />
              </Grid.Column>
            </Grid>
          </Segment>
        }
      </Segment>
    );
  }
}

export default Pages;
